import React, { useMemo, useState } from "react";
import { Typography, Chip, Avatar, Tooltip } from "@mui/material";
import CustomTable from "../../../components/Table/Table";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
// import AddClient from "../AddClient/AddClient";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { useLoading } from "../../../contexts/LoadingContext";
import Modal from "../../../components/Modal/Modal";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import BusinessIcon from "@mui/icons-material/Business";
import CircleIcon from "@mui/icons-material/Circle";
import FactoryIcon from "@mui/icons-material/Factory";
import PublicIcon from "@mui/icons-material/Public";
import AddProjectResourceMapping from "../AddProjectResourceMapping/AddProjectResourceMapping";
import { useRbac } from "../../../hooks/RbacContext";
import { useAllProjectResorceMappingsViewModel } from "../ProjectResourceMappingAll/AllProjectResourceMappingViewModel";
import { useParams } from "react-router-dom";
import { useBusinessUnitApi } from "../../../hooks/useBusinessUnitApi";

const AllResourceByProject = ({ projectName }) => {
  const {
    projectResourceMappings,
    resources,
    projects,
    loading,
    error,
    getResourceName,
    getResourceFullName,
    getProjectName,
    createProjectResourceMapping,
    updateProjectResourceMapping,
    handleDelete,
    refetch,
    roles,
    getRoleName,
    getBusinessUnitName,
  } = useAllProjectResorceMappingsViewModel();

  const { showLoading, hideLoading } = useLoading();
  const projectId = useParams()?.id;

  const [isAddProjectResorceMappingOpen, setIsAddProjectResorceMappingOpen] =
    useState(false);
  const [selectedProjectResorceMapping, setSelectedProjectResorceMapping] =
    useState(null);
  const [successModal, setSuccessModal] = useState(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState(null);
  const { hasProjectPermission, checkAccess } = useRbac();
  console.log(
    "hasAcees",
    hasProjectPermission(parseInt(projectId), "resource", "add"),
    checkAccess("projectResources", "add")
  );
  const columns = [
    {
      id: "role_id",
      label: "Project Roles",
      render: (value, row) => {
        console.log("rowrow", row);
        return (
          <Typography
            variant="body2"
            noWrap
            sx={{
              fontSize: "inherit",
              display: "flex",
              color: (theme) =>
                value
                  ? theme.palette.text.primary
                  : theme.palette.text.secondary,
            }}
          >
            {getRoleName(value)}
            {row.is_project_manager ? (
              row.is_primary ? (
                <Tooltip title={"Primary Project Manager"}>
                  <Avatar
                    sx={{
                      marginLeft: "5px",
                      width: 16,
                      height: 16,
                      fontSize: "10px",
                      bgcolor: (theme) => theme.palette.text.primary,
                    }}
                  >
                    P
                  </Avatar>
                </Tooltip>
              ) : (
                <Tooltip title={"Secondary Project Manager"}>
                  <Avatar
                    sx={{
                      marginLeft: "5px",
                      width: 16,
                      height: 16,
                      fontSize: "10px",
                    }}
                  >
                    S
                  </Avatar>
                </Tooltip>
              )
            ) : null}
          </Typography>
        );
      },
      searchValue: (value) => getRoleName(value),
    },
    {
      id: "resource_id",
      label: "Members",
      render: (value) => (
        <Typography
          variant="body2"
          noWrap
          sx={{
            fontSize: "inherit",
            color: (theme) =>
              value ? theme.palette.text.primary : theme.palette.text.secondary,
          }}
        >
          {getResourceName(value)}
        </Typography>
      ),
      searchValue: (value) => getResourceName(value),
    },
    {
      id: "resource.department",
      label: "Department",
      render: (value, row) => (
        <Typography
          variant="body2"
          noWrap
          sx={{
            fontSize: "inherit",
            color: (theme) =>
              value ? theme.palette.text.primary : theme.palette.text.secondary,
          }}
        >
          {
            row.resource?.department
          //getBusinessUnitName(row.resource?.business_unit)
          }
        </Typography>
      ),
      searchValue: (value, row) =>
        row.resource?.department
        // getBusinessUnitName(row.resource?.business_unit),
    },
    {
      id: "resource.reporting_manager",
      label: "Reporting Manager",
      render: (value, row) => (
        <Typography
          variant="body2"
          noWrap
          sx={{
            fontSize: "inherit",
            color: (theme) =>
              value ? theme.palette.text.primary : theme.palette.text.secondary,
          }}
        >
          {row.resource?.reporting_manager
            ? getResourceFullName(row.resource.reporting_manager)
            : "Unknown"}
        </Typography>
      ),
      searchValue: (value, row) =>
        row.resource?.reporting_manager
          ? getResourceFullName(row.resource.reporting_manager)
          : "Unknown",
    },
  ];
  const fixedColumns = {
    left: [],
    right: ["is_active", "actions"],
  };
  const handleAddClient = () => {
    setSelectedProjectResorceMapping({ project_id: projectId });
    setIsAddProjectResorceMappingOpen(true);
  };

  const handleEditClient = (client) => {
    setSelectedProjectResorceMapping(client);
    setIsAddProjectResorceMappingOpen(true);
  };

  const handleCloseDialog = () => {
    setIsAddProjectResorceMappingOpen(false);
    setSelectedProjectResorceMapping(null);
  };

  const handleSubmit = async (formData) => {
    try {
      showLoading();
      if (selectedProjectResorceMapping?.project_resource_mapping_id) {
        await updateProjectResourceMapping(
          selectedProjectResorceMapping,
          formData
        );
        setSuccessModal({
          type: "success",
          title: "Success",
          message: "Project Member updated successfully",
        });
      } else {
        await createProjectResourceMapping(formData);
        setSuccessModal({
          type: "success",
          title: "Success",
          message: "Project Member added successfully",
        });
      }
      handleCloseDialog();
      await refetch();
    } catch (error) {
      throw error;
    } finally {
      hideLoading();
    }
  };

  const handleCloseSuccessModal = () => {
    setSuccessModal(null);
  };

  const handleDeleteClick = (projectResorceMapping) => {
    setDeleteConfirmation({
      projectResorceMapping,
      open: true,
    });
  };

  const handleDeleteConfirm = async () => {
    const projectResorceMapping = deleteConfirmation.projectResorceMapping;
    try {
      showLoading();

      await handleDelete(projectResorceMapping);
      setDeleteConfirmation(null);
      setSuccessModal({
        type: "success",
        title: "Success",
        message: "Project Member deleted successfully",
      });
    } catch (error) {
      setDeleteConfirmation(null);
      setSuccessModal({
        type: "error",
        title: "Action Failed",
        message: error.message,
      });
    } finally {
      hideLoading();
    }
  };

  const getActions = (member) => {
    const actions = [];
    if (
      hasProjectPermission(parseInt(projectId), "resource", "update") ||
      checkAccess("projectResources", "update")
    ) {
      actions.push({
        icon: <EditIcon fontSize="small" />,
        label: "Edit",
        onClick: handleEditClient,
        color: "primary",
        disabled:
          member.role_id == process.env.REACT_APP_PM_ROLE_ID ||
          member.role_id == process.env.REACT_APP_PO_ROLE_ID,
        sx: {
          "&:hover": {
            backgroundColor: (theme) =>
              theme.palette.primary.lighter || "rgba(33, 150, 243, 0.08)",
          },
        },
      });
    }
    if (
      hasProjectPermission(parseInt(projectId), "resource", "delete") ||
      checkAccess("projectResources", "delete")
    ) {
      actions.push({
        icon: <DeleteIcon fontSize="small" />,
        label: "Delete",
        onClick: handleDeleteClick,
        color: "error",
        disabled:
          member.role_id == process.env.REACT_APP_PM_ROLE_ID ||
          member.role_id == process.env.REACT_APP_PO_ROLE_ID,

        sx: {
          "&:hover": {
            backgroundColor: (theme) =>
              theme.palette.error.lighter || "rgba(211, 47, 47, 0.08)",
          },
        },
      });
    }

    return actions;
  };

  if (error) {
    return (
      <div>
        <Typography color="error">Error: {error}</Typography>
      </div>
    );
  }

  return (
    <div>
      <CustomTable
        columns={columns}
        data={projectResourceMappings}
        onAdd={handleAddClient}
        showActions={true}
        showAddButton={
          hasProjectPermission(parseInt(projectId), "resource", "add") ||
          checkAccess("projectResources", "add")
        }
        addButtonIcon={<PersonAddIcon />}
        showSearch={false}
        showFilters={false}
        showColumnVisibility={false}
        pageSize={10}
        stickyHeader={true}
        fixedColumns={fixedColumns}
        actions={getActions}
        title="Members"
        subtitle=""
        addButtonText="Add Member"
        alignment="left"
        fontSize="12px"
      />

      <AddProjectResourceMapping
        open={isAddProjectResorceMappingOpen}
        onClose={handleCloseDialog}
        initialData={selectedProjectResorceMapping}
        onSubmit={handleSubmit}
        resources={resources}
        getResourceName={getResourceName}
        projects={projects}
        getProjectName={getProjectName}
        roles={roles}
      />

      {successModal && (
        <Modal
          type={successModal.type}
          title={successModal.title}
          message={successModal.message}
          onClose={handleCloseSuccessModal}
        />
      )}

      {deleteConfirmation && (
        <ConfirmationModal
          open={true}
          title="Delete Project Member"
          message={`Do you confirm to remove "${getResourceName(
            deleteConfirmation.projectResorceMapping.resource_id
          )}" from "${projectName}"?`}
          onClose={() => setDeleteConfirmation(null)}
          onConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
};

export default AllResourceByProject;
